import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Divider, Stack, Paper, Container } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import LoginForm from "./LoginForm";
import ContinueWithGoogle from "./components/ContinueWithGoogle";
import { trackEvent } from "../../analytics";
import Footer from "../common/Footer";

export default function LoginView() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ref = searchParams.get("ref");

  const handleGoogleSignIn = () => {
    trackEvent("login", { method: "google" });
    const serverUrl = process.env.REACT_APP_API_URL;
    const url = ref
      ? `${serverUrl}/auth/signin/google/preflight?ref=${encodeURIComponent(ref)}`
      : `${serverUrl}/auth/signin/google`;
    window.location.href = url;
  };

  const handleSignUp = () => {
    navigate(ref ? `/register?ref=${encodeURIComponent(ref)}` : "/register");
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          py: 5,
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Login Card */}
          <Paper
            elevation={3}
            sx={{
              width: "100%",
              padding: { xs: 3, sm: 4 },
              borderRadius: 3,
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Sign In Header */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mb: 3,
              }}
            >
              {/* Logo instead of Avatar for login form */}
              <Box sx={{ textAlign: "center", mb: 2 }}>
                <img
                  src="/logo.png"
                  alt="Podcast Assistant Logo"
                  style={{
                    height: "80px",
                    width: "auto",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
              <Typography
                component="h1"
                variant="h5"
                sx={{ fontWeight: 600, color: "text.primary" }}
              >
                Sign In
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, textAlign: "center" }}
              >
                Welcome back! Please sign in to your account
              </Typography>
            </Box>

            {/* Social Login */}
            <Box sx={{ mb: 3 }}>
              <ContinueWithGoogle onClick={handleGoogleSignIn} />
            </Box>

            {/* Divider */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{ mb: 3 }}
            >
              <Divider sx={{ flexGrow: 1 }} />
              <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                or continue with email
              </Typography>
              <Divider sx={{ flexGrow: 1 }} />
            </Stack>

            {/* Login Form */}
            <LoginForm />
          </Paper>

          {/* Footer Links */}
          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="body2" color="text.secondary">
              Don't have an account?{" "}
              <Typography
                component="span"
                variant="body2"
                sx={{
                  color: "primary.main",
                  cursor: "pointer",
                  fontWeight: 500,
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
                onClick={handleSignUp}
              >
                Sign up
              </Typography>
            </Typography>
          </Box>
        </Box>
        <Footer />
      </Box>
    </Container>
  );
}
